import React, { useEffect, useState } from 'react';
import { Box, InputAdornment, Stack, Tab, Tabs, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import useToast from '../../../../hooks/useToast';
import CusSwitch from '../../../../components/material-ui/CusSwitch';
import CusInput from '../../../../components/material-ui/CusInput';
import { API_CASINO } from '../../../../api/casino.js';
import useNumberParams from '../../../../hooks/useNumberParams.js';
import CasinoBtnSave from '../../../../components/casino/CasinoBtnSave.jsx';
import { TEST_MODE } from '../../../../enums/enums.js';
import TabsLanguage from '../../../../components/widgets/TabsLanguage.jsx';
import { useAppSelector } from '../../../../store/index.js';
import ShowContainer from '../../../../components/material-ui/ShowContainer.jsx';

export default function LangLinkContent() {
  const { t } = useTranslation();
  const casinoId = useNumberParams('casinoId');
  const { infoToast, successToast } = useToast();
  const languages = useAppSelector((state) => state.info.casinoLanguages);
  const [defaultLanguage, setDefaultLanguage] = useState('en');
  const [languageFields, setLanguageFields] = useState({ en: { enabled: true } });
  const [activeTab, setActiveTab] = useState();

  const sizeInput = 6;
  const choseField = languageFields?.[activeTab] || {};

  const currentLang = languages.find((el) => el.lang == activeTab);

  useEffect(() => {
    if (!casinoId) return;

    API_CASINO.get
      .props({ casinoId, propsCasino: ['langList'] })
      .then((e) => {
        const info = e.data.info;
        const langList = {};

        for (let lang in info.langList) {
          const langInfo = info.langList[lang];
          langInfo.enabled = true;
          langList[lang] = langInfo;
        }

        setLanguageFields(langList);
        const langs = Object.keys(langList);
        const defaultLang = langs.find((lang) => langList[lang].default);
        setDefaultLanguage(defaultLang);
      })
      .catch(console.error);
  }, [casinoId]);

  const changeLanguages = (name, val, lang) => {
    setLanguageFields((prev) => {
      const prevInfo = JSON.parse(JSON.stringify(prev));
      if (!prevInfo[lang]) prevInfo[lang] = {};
      prevInfo[lang][name] = val;

      return prevInfo;
    });
  };

  const onSaveClick = () => {
    const langList = {};

    for (let lang in languageFields) {
      const field = languageFields[lang];
      if (!field.enabled) continue;
      if (!langList[lang]) langList[lang] = {};
      langList[lang].default = defaultLanguage == lang || false;
      langList[lang].channelLink = field.channelLink || '';
      langList[lang].chatLink = field.chatLink || '';
      langList[lang].postLink = field.postLink || '';
      langList[lang].reviewLink = field.reviewLink || '';
      langList[lang].supportChat = field.supportChat || '';
      langList[lang].supportEmail = field.supportEmail || '';
    }

    if (TEST_MODE) {
      console.log('langList', langList);

      return;
    }

    API_CASINO.update({ casinoId: +casinoId, langList: langList })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2}>
      <Box sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
        <TabsLanguage lang={activeTab} setLang={setActiveTab} />
      </Box>
      <Stack mt={-1}>
        <ShowContainer condition={currentLang}>
          <Typography>
            {t('Lang')}: {currentLang?.label}
          </Typography>
        </ShowContainer>
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack display={'flex'} direction={'row'} gap={2}>
              <Box>
                <Stack display={'flex'} direction="row" alignItems="center">
                  <CusSwitch
                    label={'Enabled'}
                    checked={choseField.enabled}
                    onChange={() => {
                      if (activeTab == defaultLanguage) {
                        infoToast(
                          'You cannot turn off a language if it is enabled as the "Default Language".'
                        );
                        return;
                      }
                      changeLanguages('enabled', !choseField.enabled, activeTab);
                    }}
                  />
                  <CusSwitch
                    label={'Default language'}
                    checked={activeTab == defaultLanguage}
                    onChange={() => {
                      changeLanguages('enabled', true, activeTab);
                      setDefaultLanguage(activeTab);
                      const textTurnOf =
                        'Turn On a different default language and it will be turned off automatically here!';

                      if (activeTab == defaultLanguage) infoToast(textTurnOf);
                    }}
                  />
                </Stack>
              </Box>
            </Stack>
          </Grid>

          <Grid size="grow" container spacing={1}>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.channelLink || ''}
                label={'Telegram channel casino'}
                placeholder={' https://t.me/some_channel'}
                onChange={(e) => changeLanguages('channelLink', e.target.value, activeTab)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.postLink || ''}
                label={'Telegram post for a gaming website'}
                placeholder={' https://t.me/some_channel/some_public_post'}
                onChange={(e) => changeLanguages('postLink', e.target.value, activeTab)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.reviewLink || ''}
                label={'Reviews on the Telegram channel'}
                placeholder={' https://t.me/some_review_channel'}
                onChange={(e) => changeLanguages('reviewLink', e.target.value, activeTab)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                label={'Telegram technical support chat'}
                placeholder={'nickname_of_support'}
                value={choseField.supportChat || ''}
                startAdornment={
                  <InputAdornment sx={{ m: 0 }} position="start">
                    <Typography lineHeight={'100%'}>@</Typography>
                  </InputAdornment>
                }
                onChange={(e) => {
                  const value = e.target.value.replaceAll('@', '');
                  changeLanguages('supportChat', value, activeTab);
                }}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.chatLink || ''}
                label={'Casino Telegram Chat'}
                placeholder={' https://t.me/some_telegram_chat'}
                onChange={(e) => changeLanguages('chatLink', e.target.value, activeTab)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.supportEmail || ''}
                label={'Technical support email'}
                placeholder={'support@example.tld'}
                onChange={(e) => changeLanguages('supportEmail', e.target.value, activeTab)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Stack>

      <CasinoBtnSave onClick={onSaveClick} />
    </Stack>
  );
}
